const INSUFFICIENT_PERMISSIONS_CODES=[403,412],DEFAULT_ERROR_MESSAGE="Oops! Something went wrong!";export{DEFAULT_ERROR_MESSAGE,INSUFFICIENT_PERMISSIONS_CODES};
